<template>
<div class="not-found">
    <div>
        Nema ničeg ovdje :( Ova stranica ne postoji ili je pomaknuta negdje drugdje.
    </div>
    <a href="/" class="return-home">Povratak na početnu &#10230;</a>
</div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      didResetSucceed: false,
      isResetOver: false,
      newPassword: "",
      repeatedNewPassword: "",
      isPasswordValid: true,
      isRepeatedPasswordValid: true
    };
  },
  methods: {
    validatePassword: function() {
        let pass = this.newPassword;
        this.isPasswordValid = pass && pass.length >= 8 && pass.toLowerCase() !== pass && /\d/.test(pass);
    },
    validateRepeatedPassword: function() {
        this.isRepeatedPasswordValid = this.newPassword === this.repeatedNewPassword;
    },
    isFormValid: function() {
        return this.isPasswordValid && this.isRepeatedPasswordValid;
    },
    reset: function() {
        if(this.isFormValid())
            this.$axios.post(`${this.$API_URL}/user/reset-password`, {
                code: this.$route.query.code,
                newPassword: this.newPassword
            })
            .then(() => {
                this.didResetSucceed = true;
                this.isResetOver = true;
            })
            // eslint-disable-next-line
            .catch(error => {
                this.didResetSucceed = false;
                this.isResetOver = true;
            });
    }
  }
};
</script>

<style scoped>
.not-found {
    position: absolute;
    top: 40%;
    left: 10%;
}

.not-found div {
    font-size: 24px;
    margin-bottom: 20px;
}

.return-home {
    font-size: 18px;
    text-decoration: none;
}

.not-found div,
.return-home {
    color: #30cec1;
}
</style>